import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-6 bg-white">
     

      <h1 className="text-2xl font-bold mb-6 text-gray-800">Privacy Policy</h1>

      <section className="mb-6">
        <p className="mb-4 text-gray-600">
          This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </p>
        <p className="mb-4 text-gray-600">
          We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Interpretation and Definitions</h2>
        <h3 className="text-lg font-medium mb-2 text-gray-700">Interpretation</h3>
        <p className="mb-4 text-gray-600">
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>
        
        <h3 className="text-lg font-medium mb-2 text-gray-700">Definitions</h3>
        <p className="mb-2 text-gray-600">For the purposes of this Privacy Policy:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-2">
          <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
          <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
          <li><strong>Application</strong> refers to Ducktail, the software program provided by the Company.</li>
          <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Ducktail Private Limited, Tamilnadu.</li>
          <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
          <li><strong>Country</strong> refers to: Tamil Nadu, India</li>
          <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
          <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
          <li><strong>Service</strong> refers to the Application or the Website or both.</li>
          <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
          <li><strong>Third-party Social Media Service</strong> refers to any website or any social network website through which a User can log in or create an account to use the Service.</li>
          <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
          <li><strong>Website</strong> refers to Ducktail Construction Platform, accessible from http://www.ducktail.in</li>
          <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
        </ul>
      </section>

      {/* ... continuing with all the remaining sections ... */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Collecting and Using Your Personal Data</h2>
        <h3 className="text-lg font-medium mb-2 text-gray-700">Types of Data Collected</h3>
        
        <h4 className="text-base font-medium mb-2 text-gray-700">Personal Data</h4>
        <p className="mb-2 text-gray-600">
          While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-1">
          <li>Email address</li>
          <li>First name and last name</li>
          <li>Phone number</li>
          <li>Service Provider's Certifications</li>
          <li>Address, State, Province, ZIP/Postal code, City</li>
          <li>Usage Data</li>
        </ul>

        {/* ... all other sections from the original code ... */}
      </section>

      {/* ... all remaining sections from the original code ... */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-3 text-gray-700">Contact Us</h2>
        <p className="mb-2 text-gray-600">
          If you have any questions about this Privacy Policy, You can contact us:
        </p>
        <p className="text-gray-600">
          By email: connect@ducktail.in
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;